import { Slider, TableCell, TableRow, Tooltip } from "@mui/material";
import { debounce } from "lodash-es";
import styled from "styled-components";

interface Props {
  substance: string;
  dwelling: string;
  fuel: string;
  appliance: string;
  weight: number;
  onChange: (value: number) => void;
  className?: string;
  readOnly: boolean;
}
export function RestrictionRow(props: Props) {
  return (
    <StyledTableRow className={props.className}>
      <TableCell component="th" scope="row">
        <span dangerouslySetInnerHTML={{ __html: props.substance }} />
      </TableCell>
      <TableCell component="th" scope="row">
        <span dangerouslySetInnerHTML={{ __html: props.dwelling }} />
      </TableCell>
      <TableCell component="th" scope="row">
        <span dangerouslySetInnerHTML={{ __html: props.fuel }} />
      </TableCell>
      <TableCell component="th" scope="row">
        <span dangerouslySetInnerHTML={{ __html: props.appliance }} />
      </TableCell>

      <TableCell component="th" scope="row" width={200} className="table-cell-percentage">
        <Slider
          disabled={props.readOnly}
          size="small"
          min={0}
          max={200}
          value={props.weight}
          valueLabelDisplay="auto"
          components={{
            ValueLabel: ValueLabelComponent,
          }}
          onChange={debounce((event, newValue) => {
            if (!Array.isArray(newValue)) props.onChange(newValue);
          })}
        />
      </TableCell>
    </StyledTableRow>
  );
}

export function ValueLabelComponent(props: { children: React.ReactElement; value: number }) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value} arrow>
      {children}
    </Tooltip>
  );
}

const StyledTableRow = styled(TableRow)`
  .table-cell-percentage {
    display: flex;
    flex-direction: row;
    min-width: 200px;
    gap: ${({ theme }) => theme.spacing(1)};
  }

  .MuiSlider-valueLabel {
    z-index: 99999;
  }

  .MuiSlider-root {
    width: var(--slider-width);
  }
`;
